import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
    standalone: true,
    // All controls inside the form need access to the form submit event
    // so that they can show unaddressed errors at that time.
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'form',
})
export class FormSubmitDirective implements OnInit {
    private submit = new Subject<SubmitEvent>();
    public submit$ = this.submit.asObservable();

    public constructor(
        private readonly renderer: Renderer2,
        private readonly element: ElementRef,
    ) {}

    public ngOnInit() {
        // Todo: https://github.com/ionic-team/ionic-framework/issues/19368
        // Without an `<input hidden type="submit" />`, <enter> won't fire a submit event.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const hiddenSubmitInput = this.renderer.createElement('input');

        this.renderer.setAttribute(hiddenSubmitInput, 'hidden', '');
        this.renderer.setAttribute(hiddenSubmitInput, 'type', 'submit');
        this.renderer.appendChild(this.element.nativeElement, hiddenSubmitInput);
    }

    @HostListener('submit', ['$event'])
    public formSubmissionListener($event: SubmitEvent) {
        this.submit.next($event);
    }
}
